export const allCompanyPortfolio = {
    title: 'Technology portfolio analysis',
    description: `All of the technology group (cluster) of the specified companies' patent applications are displayed for comparison between companies. 
        This provides an overall view of the technology landscape. 
        The placement of the clusters represents the trends of the entire theme, while the size of the bubble represents the unique value (score) of each company.`,
    displayColumn1: 'Display in one column',
    displayColumn2: 'Display in two columns',
    company: 'Company',
    xSelect1: 'Score (Technological Progress)',
    ySelect1: 'Market Expectation',
    bubbleSelect1: 'Score (Technological Competitiveness)',
    bubbleSelect2: 'Number of Patent Applications',
    bubbleSelect3: 'Number of Forward Citations (Average)',
    copy: 'Copy',
    yAxisUnit: 'bn yen',
    labelArrayOverFlowMsg: 'Up to five labels can be displayed.',

    // 設定画面
    xLabel: 'X Axis',
    yLabel: 'Y Axis',
    setting: 'Configuration',
    size: 'Bubble Size',
    zoomSlider: 'Zoom Slider',
    nonDisplay: 'Do not fix the labels',
    initButton: 'Revert to Default'
}
